export default "__VITE_ASSET__723cHqgC__"